module.exports = __webpack_public_path__ + "static/terminalMapBW.d65ef223.png";